/**
 * The fairness page's default copy (the rule is in `shared.ts`): its title, and its two tools'
 * headings, fields and actions. What the page says of the algorithm, a verification's verdict and
 * the facts of an open or a seed are the platform's (`fairnessReadout.ts`).
 */

/** The fairness page's words, by section. */
export interface FairnessCopy {
  /** The page's h1. */
  intro: { title: string };
  /** The verifier: its heading, the open's id and its action. */
  verify: {
    title: string;
    /** The field's accessible name, and the hint it shows while empty. */
    openId: { label: string; placeholder: string };
    /** The form's action, and its words while the verification runs. */
    submit: { label: string; busyLabel: string };
  };
  /** The seed lookup: its heading, the day and its action. */
  seed: {
    title: string;
    date: { label: string };
    submit: { label: string; busyLabel: string };
  };
}

/** None of the page's words names a term, the store or its currency, so it takes nothing. */
export function defaultFairnessCopy(): FairnessCopy {
  return {
    intro: { title: "Provably fair" },
    verify: {
      title: "Verify an open",
      openId: { label: "Open ID", placeholder: "01K…" },
      submit: { label: "Verify", busyLabel: "Verifying…" },
    },
    seed: {
      title: "Daily server seed",
      date: { label: "Date (UTC)" },
      submit: { label: "Look up", busyLabel: "Loading…" },
    },
  };
}
